<script setup>
import { computed, getCurrentInstance } from 'vue';

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Computed Property for User Preference
const lineWrapping = computed(() => {
    return store.getters['user/pref']('codeMirror_lineWrapping');
});

// Methods
const onClick = () => {
    store.dispatch('user/setPref', {
        name: 'codeMirror_lineWrapping',
        value: !lineWrapping.value
    });
};
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="onClick">
        <span
            :class="{ 'bi-square': !lineWrapping, 'bi-check-square': lineWrapping }"
            class="me-2"
        />
        Line wrapping
    </button>
</template>